import Avatar from 'material-ui/Avatar';
import Chip from 'material-ui/Chip';
import * as React from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {IMenuItems} from '../../../interfaces';
import {dispatch} from '../../../utils/generalUtils';
import './formComponents.scss';
import {Select} from './Select';
import {TextInput} from './TextInput';
import {hideAlert} from '../../../actions/miscellaneousActions';
import {PerfectScrollbar} from '../PerfectScrollbar';

type module = string | string[];

export interface IInputFieldProps {
    id: string;
    model: string;
    label: string;
    hintText: string;
    defaultValue?: module;
    formmodel?: string;
    type: string;
    minValue?: number;
    maxValue?: number;
    color?: string;
    menuItems?: IMenuItems[];
    alertType?: string;
    noChips?: boolean;
    multi?: boolean;
    required?: boolean;
    onChange?: (value) => void;
    onMenuItemDelete?: (value) => void;
    disabled?: boolean;
    selected?: string;
}

export interface IInputFieldState {
    value: module;
    selectedItems: any[];
    selectedLabelItems: any[];
    fullModelName: string;
    isEmpty: boolean;
}

export class InputFieldImpl extends React.Component<IInputFieldProps, IInputFieldState> {
    constructor(props: IInputFieldProps) {
        super(props);
        if (props.defaultValue && !props.multi) {
            dispatch(actions.change(`${props.formmodel}${props.model}`, props.defaultValue));
        } else { 
            dispatch(actions.change(`${props.formmodel}${props.model}`, this.getDefaultValues(props.defaultValue)));
        }
        this.state = {
            // value: props.defaultValue || '',
            value: props.defaultValue || '',
            fullModelName: `${props.formmodel}${props.model}`,
            selectedLabelItems: props.defaultValue && props.multi ? this.getDefaultLabels(props.defaultValue) : [],
            selectedItems: props.defaultValue && props.multi ? this.getDefaultValues(props.defaultValue) : [],
            isEmpty: props.alertType === 'validation'
        };
    }

    public getDefaultValues = (defaultValues) => {
        const defaultSelectedValues = (defaultValues || []).map((data) => data.value);
        return defaultSelectedValues;
    }

    public getDefaultLabels = (defaultValues) => {
        const defaultSelectedLabels = (defaultValues || []).map((data) => data.label);
        return defaultSelectedLabels;
    }

    public componentWillReceiveProps(nextProps: IInputFieldProps) {
        const {value, selectedItems} = this.state;
        if (!nextProps.multi && nextProps.defaultValue && !value) {
            this.setState({
                value: nextProps.defaultValue
            });
            dispatch(actions.change(this.state.fullModelName, nextProps.defaultValue));
        } else if (nextProps.multi && nextProps.defaultValue && !value) {
            this.setState({
                selectedItems: nextProps.defaultValue as string[]
            });
        }
        if (nextProps.alertType && (!nextProps.multi && !value)) {
            this.setState({
                isEmpty: nextProps.alertType === 'validation'
            });
        } else if (nextProps.alertType && (nextProps.multi && selectedItems.length <= 0)) {
            this.setState({
                isEmpty: nextProps.alertType === 'validation'
            });
        }

    }

    public handleTextFieldValueChangeById = async (event, value, label?) => {
        const {multi, onChange} = this.props;
        // const labels = this.state.selectedItems.length > 0 ? this.state.selectedItems : value;
        if ( label === undefined) {
            await this.setState({
                selectedItems:[],
                selectedLabelItems: [],
            });
        }
        const labels = value ? value : this.state.selectedItems;
        if (multi && label) {
            await this.setState({
                selectedItems: labels,
                value: value,
                isEmpty: value.length <= 0
            });
            hideAlert();
            dispatch(actions.change(this.state.fullModelName, value));
            if (onChange) {
                // if (multi) 
                    onChange({label, value: value});
                // else onChange({label, value: value[value.length - 1]});
            }
            return; 
        }
        await this.setState({
            value,
            isEmpty: value.length <= 0
        });
        hideAlert();
        if( label === undefined) {
            dispatch(actions.change(this.state.fullModelName, []));
        } else {
            dispatch(actions.change(this.state.fullModelName, value));
        }
        if (onChange) {
            if( label === undefined) {
                onChange([]);
            } else {
                onChange(value);
            }
        }
    }

    //  public handleTextFieldValueChange = (event, value, label?) => {
    //     const {multi, onChange} = this.props;
    //     const labels = this.state.selectedItems.length > 0 ? this.state.selectedItems : [];
    //     labels.push(label);
    //     if (multi && label) {
    //         this.setState({
    //             selectedItems: labels,
    //             value: value,
    //             isEmpty: value.length <= 0
    //         });
    //         hideAlert();
    //         dispatch(actions.push(this.state.fullModelName, value[value.length - 1]));
    //         if (onChange) {
    //             onChange({label, value: value[value.length - 1]});
    //         }
    //         return;
    //     }
    //     this.setState({
    //         value,
    //         isEmpty: value.length <= 0
    //     });
    //     hideAlert();
    //     dispatch(actions.change(this.state.fullModelName, value));
    //     if (onChange) {
    //         onChange(value);
    //     }
    // }
    public handleTextFieldValueChange = (event, value, label?) => {
        const {multi, onChange} = this.props;
        const labels = this.state.selectedItems.length > 0 ? this.state.selectedItems : [];
        labels.push(label);
        if (multi && label) {
            this.setState({
                selectedItems: labels,
                value: value,
                isEmpty: value.length <= 0
            });
            hideAlert();
            dispatch(actions.push(this.state.fullModelName, value[value.length - 1]));
            if (onChange) {
                onChange({label, value: value[value.length - 1]});
            }
            return;
        }
        this.setState({
            value,
            isEmpty: value.length <= 0
        });
        hideAlert();
        dispatch(actions.change(this.state.fullModelName, value));
        if (onChange) {
            onChange(value);
        }
    }


    public handleChipDelete = (e, value, index) => {
        const selectedItems = this.state.selectedItems.filter(selectedValue => selectedValue !== value);
        this.setState({
            selectedItems
        });
        if (this.props.onMenuItemDelete) {
            this.props.onMenuItemDelete(value);
        }
    }

    public renderChips = () => {
        if (this.props.multi) {
            if(this.state.selectedLabelItems.length) {
                return this.state.selectedLabelItems.map((value, index) => {
                    const selectedValue = value.split(' ');
                    const avatar = selectedValue.length > 1 ?
                        `${selectedValue[0].substring(0, 1)}${selectedValue[1].substring(0, 1)}` :
                        `${selectedValue[0].substring(0, 2)}`;
                    return <Chip
                        className={`mui-chip ${this.props.disabled ? 'disabled' : ''}`}
                        key={index}
                        onRequestDelete={(e) => this.handleChipDelete(e, value, index)}
                        onClick={null}
                    >
                        <Avatar size={32}>
                            {avatar.toUpperCase()}
                        </Avatar>
                        {value}
                    </Chip>;
                });
            } else {
                return this.state.selectedItems.map((value, index) => {
                    const selectedValue = value.split(' ');
                    const avatar = selectedValue.length > 1 ?
                        `${selectedValue[0].substring(0, 1)}${selectedValue[1].substring(0, 1)}` :
                        `${selectedValue[0].substring(0, 2)}`;
                    return <Chip
                        className={`mui-chip ${this.props.disabled ? 'disabled' : ''}`}
                        key={index}
                        onRequestDelete={(e) => this.handleChipDelete(e, value, index)}
                        onClick={null}
                    >
                        <Avatar size={32}>
                            {avatar.toUpperCase()}
                        </Avatar>
                        {value}
                    </Chip>;
                });
            }
        }
    }

    public getMenuItems = (menuItems) => {
        const selectedLabels = this.state.selectedItems;
        return menuItems.filter((item) => selectedLabels.indexOf(item.label) < 0);
    }

    public renderInputField = () => {
        const {id, label, hintText, type, required} = this.props;
        const {value, selectedItems, isEmpty} = this.state;
        switch (type) {
            case 'text':
                return <div className="text-input">
                    <div className="input-label" style={{width: '40%'}}>
                        <label htmlFor={id}>{label}</label>
                    </div>
                    <div className="input-field">
                        <TextInput
                            disabled={this.props.disabled || false}
                            hintText={hintText}
                            id={id}
                            color={'white'}
                            errorText={(required && isEmpty) ? 'This field is required' : ''}
                            type={type}
                            value={this.state.value as string}
                            onChange={this.handleTextFieldValueChange}
                        />
                    </div>
                </div>;
            case 'number':
                return <div className="text-input">
                    <div className="input-label" style={{width: '40%'}}>
                        <label htmlFor={id}>{label}</label>
                    </div>
                    <div className="input-field">
                        <TextInput
                            disabled={this.props.disabled || false}
                            hintText={hintText}
                            id={id}
                            minvalue={this.props.minValue}
                            maxvalue={this.props.maxValue}
                            color={'white'}
                            errorText={(required && isEmpty) ? 'This field is required' : ''}
                            type={type}
                            value={this.state.value as string}
                            onChange={this.handleTextFieldValueChange}
                        />
                    </div>
                </div>;
            case 'password':
                return <div className="text-input">
                    <div className="input-label" style={{width: '40%'}}>
                        <label htmlFor={id}>{label}</label>
                    </div>
                    <div className="input-field">
                        <TextInput
                            disabled={this.props.disabled || false}
                            hintText={hintText}
                            id={id}
                            type={type}
                            color={'white'}
                            errorText={(required && isEmpty) ? 'This field is required' : ''}
                            onChange={this.handleTextFieldValueChange}
                        />
                    </div>
                </div>;
            case 'select':
            case 'selectById':
                return <div className="text-input mui-select sel-placement">
                    <div className="multi-select-wrapper">
                        <div className="input-label" style={{width: '40%'}}>
                            <label htmlFor={id}>{label}</label>
                        </div>
                        <div className="input-field">
                            <Select
                                color={this.props.color || 'black'}
                                disabled={this.props.disabled || false}
                                errorText={(required && isEmpty) ? 'This field is required' : ''}
                                multiple={this.props.multi}
                                onChange={ type === 'select' ? this.handleTextFieldValueChange : this.handleTextFieldValueChangeById }
                                hintText={hintText}
                                menuItems={this.props.noChips ? this.props.menuItems : this.getMenuItems(this.props.menuItems)}
                                value={this.props.multi ? selectedItems : value}
                            />
                        </div>
                    </div>
                    {!this.props.noChips && <div className="chips">
                        <PerfectScrollbar className="list-page-container">
                            <div className="separator"/>
                            <div className="chips-container">
                                {this.renderChips()}
                            </div>
                        </PerfectScrollbar>
                    </div>}
                </div>;

            default:
                return <div className="text-input">
                    <div className="input-label" style={{width: '40%'}}>
                        <label htmlFor={id}>{label}</label>
                    </div>
                    <div className="input-field">
                        <TextInput
                            disabled={this.props.disabled || false}
                            hintText={hintText}
                            id={id}
                            color={'white'}
                            errorText={(required && isEmpty) ? 'This field is required' : ''}
                            type={type}
                            onChange={this.handleTextFieldValueChange}
                            value={this.state.value as string}
                        />
                    </div>
                </div>;
        }
    }

    public render() {
        return this.renderInputField();
    }
}

export function mapStateToProps(state) {
    return {
        alertType: state.miscellaneous.get('alertType')
    };
}

export const InputField = connect<{}, {}, IInputFieldProps>(mapStateToProps)(InputFieldImpl);
// InputField  01/19/2023  02:07 PM 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/InputField.tsx